
      import Comparison from './comparison.vue'
      import type { App, Plugin } from 'vue'

      export const ComparisonPlugin: Plugin = {
        install(app: App) {
          app.component('Comparison', Comparison)
        },
      }
      export { Comparison }
      